import { cva } from 'class-variance-authority';
import { FontWeights } from '../enums/font-weights';
import { TextSizes } from '../enums/typography-text-sizes';

export const textVariants = cva('', {
  variants: {
    size: {
      [TextSizes.XL]: 'text-xl leading-[1.875rem]',
      [TextSizes.LG]: 'text-lg leading-7',
      [TextSizes.MD]: 'text-base leading-6',
      [TextSizes.SM]: 'text-sm leading-5',
      [TextSizes.XS]: 'text-xs leading-[1.125rem]',
    },
    weight: {
      [FontWeights.REGULAR]: 'font-normal',
      [FontWeights.MEDIUM]: 'font-medium',
      [FontWeights.SEMIBOLD]: 'font-semibold',
      [FontWeights.BOLD]: 'font-bold',
    },
  },
});
